import React from 'react';
import PropTypes from 'prop-types';
import Money from '../../../common/money';
import Num from '../../../common/Num';

const GiftCardStatistics = ({ soldCount, outstandingBalance }) => (
  <div className="o-wrapper o-wrapper--tiny u-bg-white u-pv u-ph+">
    <div className="layout">
      <div className="layout__item u-1/2-large-and-up u-text-center">
        <div className="delta dark-mode-grey">
          Total gift cards issued
        </div>
        <div className="u-co-primary u-mt- u-type--bold">
          <Num fallback="-">{soldCount}</Num>
        </div>
      </div>
      <div className="layout__item u-1/2-large-and-up u-text-center">
        <div className="delta dark-mode-grey">
          Total outstanding balance
        </div>
        <div className="u-co-primary u-mt- u-type--bold">
          <Money>{outstandingBalance}</Money>
        </div>
      </div>
    </div>
  </div>
);
GiftCardStatistics.propTypes = {
  soldCount: PropTypes.number,
  outstandingBalance: PropTypes.number,
};
GiftCardStatistics.defaultProps = {
  soldCount: null,
  outstandingBalance: null,
};

export default GiftCardStatistics;
